import { ChangeModel } from '../model/change.model';
import { Operation, OperationId } from '../model/operation.model';
import { v7 as uuidv7 } from 'uuid';

export const calculateInverse = (operation: Operation): Operation => {
  const invertedChanges: ChangeModel[] = [];

  for (const change of operation.changes) {
    switch (change.type) {
      case 'create:node': {
        invertedChanges.push({
          type: 'delete:node',
          id: change.id,
          status: 'end',
          data: change.data,
        });
        break;
      }
      case 'create:edge': {
        invertedChanges.push({
          type: 'delete:edge',
          id: change.id,
          status: 'end',
          data: change.data,
        });
        break;
      }
      case 'create:drilldown': {
        invertedChanges.push({
          type: 'delete:drilldown',
          id: change.id,
          status: 'end',
          data: change.data,
        });
        break;
      }
      case 'delete:node': {
        invertedChanges.push({
          type: 'create:node',
          id: change.id,
          status: 'end',
          data: change.data,
        });
        break;
      }
      case 'delete:edge': {
        invertedChanges.push({
          type: 'create:edge',
          id: change.id,
          status: 'end',
          data: change.data,
        });
        break;
      }
      case 'move': {
        // this will likely need to be refined
        if (change.status === 'start') {
          invertedChanges.push({
            type: 'move',
            status: 'end',
            id: change.id,
            data: change.data,
          });
        }
        break;
      }
      case 'resize': {
        // this will likely need to be refined
        if (change.status === 'start') {
          invertedChanges.push({
            type: 'resize',
            status: 'end',
            id: change.id,
            data: {
              width: change.data.width,
              height: change.data.height,
              x: change.data.x,
              y: change.data.y,
            },
          });
        }
        break;
      }
      case 'update:node': {
        invertedChanges.push({
          type: 'update:node',
          id: change.id,
          status: 'end',
          data: {
            before: change.data.after,
            after: change.data.before,
          },
        });
        break;
      }
      case 'update:edge': {
        invertedChanges.push({
          type: 'update:edge',
          id: change.id,
          status: 'end',
          data: {
            before: change.data.after,
            after: change.data.before,
          },
        });
        break;
      }
      case 'update:drilldown': {
        invertedChanges.push({
          type: 'update:drilldown',
          id: change.id,
          status: 'end',
          data: {
            before: change.data.after,
            after: change.data.before,
          },
        });
        break;
      }
    }
  }

  return {
    opId: uuidv7() as OperationId,
    changes: invertedChanges,
    clientId: operation.clientId,
    timestamp: Date.now(),
  };

  // sort through seenNodePositions

  // if node added, inverse is delete node
  // if node deleted, inverse is add  node (need full node data)
  // if node moved, inverse is get position from first change with same NodeId and set back to that
  // if node resized, inverse is get size from first change with sameNodeId and set back to that
  // if node updated, inverse is get previous values from patch and set back to those
};
